import { useContext, useEffect, useReducer, useState } from "react";
import './MembershipBenefits.css';
import { Button, Card, Footer } from "@nxtvid/component-library";
import trackPageView from "../../Utilities/trackPageView";
import handleVideographerSignUpButtonClick from "../../Utilities/handleVideographerSignUpButtonClick";
import { UserContext } from "../../Contexts/UserContext";

const MembershipBenefits = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [previousImageIndex, setPreviousImageIndex] = useState(null);
    const homePageImages = [require('../../Images/homepage-images/Unsplash1.webp'), require('../../Images/homepage-images/Unsplash2.webp'), require('../../Images/homepage-images/Unsplash3.webp'), require('../../Images/homepage-images/Unsplash4.webp'), require('../../Images/homepage-images/Unsplash5.webp')]
    const bts_img = require('../../Images/homepage-images/Unsplash5.webp')
    const { userInfo, setUserInfo } = useContext(UserContext);

    //mixpanel page tracking
    useEffect(() => {
      const cleanup = trackPageView(userInfo, "Membership Benefits"); // Track page view and get cleanup function
  
      return () => {
        cleanup(); // Call the cleanup function when the component unmounts
      };
    }, [userInfo]);
    
    // Crossfade image carousel
    useEffect(() => { 
          const interval = setInterval(() => {
            setPreviousImageIndex(currentImageIndex);
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % homePageImages.length);
          }, 3000); // 3 seconds
      
          return () => {clearInterval(interval)};
        }, [currentImageIndex, homePageImages.length]);
      
        // Clear previous image after fade-out animation (1 second)
        useEffect(() => {
          if (previousImageIndex !== null) {
            const timeout = setTimeout(() => {
              setPreviousImageIndex(null);
            }, 1000); // Match this duration with the CSS animation duration
      
            return () => {clearTimeout(timeout)};
          }
        }, [previousImageIndex]);


        const FAQSection = () => {
            const initialState = JSON.parse(localStorage.getItem("faqState")) || [];
          
            const faqReducer = (state, action) => {
              switch (action.type) {
                case "TOGGLE_FAQ":
                  if (state.includes(action.index)) {
                    // Remove index if already active
                    return state.filter((i) => i !== action.index);
                  } else {
                    // Add index to active list
                    return [...state, action.index];
                  }
                default:
                  return state;
              }
            };
          
            const [activeIndexes, dispatch] = useReducer(faqReducer, initialState);
          
            // Save state to localStorage whenever it changes
            useEffect(() => {
              localStorage.setItem("faqState", JSON.stringify(activeIndexes));
            }, [activeIndexes]);
          
            const faqs = [
              {
                question: "How do I find out if my application is approved?",
                answer: "You’ll receive an email notifying you about your application status, along with the next steps to set up your profile and start connecting with businesses.",
              },
              {
                question: "How will potential clients find my profile?",
                answer: "Your profile is promoted through social media, targeted ads, and our outreach efforts to connect you with the right businesses. It’s designed to make it easy for clients to discover your expertise.",
              },
              {
                question: "How do I know if I got a lead?",
                answer: "We’ll notify you via email and direct messages on the platform whenever a business inquires about your services. You’ll also receive an RFP (Request for Proposal) with details about the project and client expectations.",
              },
              {
                question: "How quickly do we have to decide on a gig?",
                answer: "We recommend responding within 24–48 hours. Brands typically shortlist three studios per project, so quick responses improve your chances of being selected.",
              },
              {
                question: "How much does NXTVid cost?",
                answer: "It’s free to list your profile on NXTVid, but we’re more than just a marketplace—we’re a private community of top-tier video talent. Every creator is carefully vetted to ensure our clients collaborate with the best in the business. If you’re ready to showcase your expertise, connect with premium brands, and elevate your career, we’d love to see your application. \n\nNXTVid takes a 10% service fee to keep our platform running smoothly and help you land premium gigs. Payments are processed securely through Stripe, which adds a small 3% fee.",
              },
            ];
          
            const toggleFAQ = (index) => {
              dispatch({ type: "TOGGLE_FAQ", index });
            };
          
            return (
              <div className="Section-5-MembershipBenefits">
                <h2 className="faq-title">Frequently Asked Questions</h2>
                <div className="faq-container">
                  {faqs.map((faq, index) => (
                    <div
                      key={index}
                      className={`faq-item ${activeIndexes.includes(index) ? "active" : ""}`}
                    >
                      <div
                        className="faq-question"
                        onClick={() => toggleFAQ(index)}
                      >
                        {faq.question}
                        <span className="faq-toggle">
                          {activeIndexes.includes(index) ? "-" : "+"}
                        </span>
                      </div>
                      {activeIndexes.includes(index) && <div className="faq-answer" >{faq.answer}</div>}
                    </div>
                  ))}
                </div>
              </div>
            );
          };

          


    return (
        <div>
            <body className="App-body-MembershipBenefits" >
            <div className="background-shades" onClick={(e)=>{e.target.style.display='none'; document.getElementsByClassName("sign-in-card")[0].style.display='none'; document.getElementsByClassName("sign-up-card")[0].style.display='none'; document.getElementsByClassName("forgot-password-card")[0].style.display='none';document.getElementsByClassName("purchase-tokens-card")[0].style.display='none'; document.getElementsByClassName('sign-in-notification-message')[0].innerHTML=''; document.getElementsByClassName('sign-up-notification-message')[0].innerHTML=''; }}/>
            
            <div className="Section-1-MembershipBenefits">
                <div className="MembershipBenefitsImage">
      <div className='crossfade-wrapper'>
        {previousImageIndex !== null && (
          <img
            key={previousImageIndex}
            src={homePageImages[previousImageIndex]}
            alt={`Slide ${previousImageIndex}`}
            className="inactive"
          />
        )}
        <img
          key={currentImageIndex}
          src={homePageImages[currentImageIndex]}
          alt={`Slide ${currentImageIndex}`}
          className="active"
        />
      </div>
    </div>
    <div className="CTA">
        <h1>
        Unlock Your Creative Potential with NXTVid
        </h1>
        <h2>
        Join a platform built for video professionals to grow, connect, and thrive in the fast-paced world of branded content.
        </h2>
        <Button className="CTA-Button" label='Apply to Join' size='medium' onClick={()=>handleVideographerSignUpButtonClick(userInfo, "Apply to Join")}/>
    </div>
            </div>
            <div className="Section-2-MembershipBenefits">
            <h1 className="Section-Header Section-3-Header">How Our Platform Works</h1>
                <div className="Section-3-Text">
                
                <div className="step">
                  <div className="step-counter">
                    1
                  </div>
                  <div className="step-1-text">
                  <h2>Apply to Join NXTVid</h2>
                    <p>Submit your application via our sign-up form, and our team will notify you about your application status via email. Once accepted, we’ll match your studio with content requests from local businesses, helping you connect with clients who value your expertise.</p>
                  </div>
                    </div>
                <div className="step">
                <div className="step-counter">
                    2
                  </div>
                  <div className="step-2-text">
                  <h2>Build Your Profile</h2>
                    <p>Easily create a profile to showcase your work, list previous clients, write your "About" section, and design custom pricing packages to simplify the hiring process for brands. Your profile is your stage—let your portfolio shine.</p>
                  
                  </div>
                    </div>
                <div className="step">
                <div className="step-counter">
                    3
                  </div>
                    <div className="step-3-text">
                    <h2>Get Discovered by Your Ideal Clients</h2>
                    <p>Your NXTVid profile will be promoted across our social media channels and indirectly through our paid ads, email campaigns, and site-wide outreach efforts. Let us help bring your talent to the right audience.</p>
                    </div>
                    </div>
                </div>
                </div>
                <div className="Section-3-MembershipBenefits">
                <h1 className="Section-Header Section-3-Header">Simplify Your Workflow</h1>
                <div className="top">
                    <div className="left">
                      <div>
                      <h3>Save Time with AI Tools</h3>
                        <ul>
                          <li><b>Storyboard Creator:</b> Quickly visualize client ideas and bring their vision to life.</li>
                          <li><b>Shot List Generator:</b> Plan your shoots efficiently with detailed, AI-crafted lists.</li>
                          <li><b>Proposal Builder:</b> Generate polished, client-ready proposals in minutes.</li>
                          <li><b>RFP Generator:</b> Land bigger projects with AI-assisted Request for Proposals.</li>
                        </ul>
                        <h3>Deliver Faster</h3>
                        <ul>
                          <li>Use AI to create and share first drafts more quickly, minimizing time spent on back-and-forth revisions.</li>
                        </ul>
                      </div>
                    
                    </div>
                    <div className="right">
                      <div>
                      <h3>Access Top-Tier Opportunities</h3>
                        <h4>Find Work That Matches Your Skills</h4>
                        <ul>
                          <li>Connect with SMBs and global brands looking for expert video specialists.</li>
                          <li>Secure gigs tailored to your expertise—whether it’s product promos, event recaps, or restaurant content.</li>
                          <li>Showcase your portfolio to attract high-value clients.</li>
                        </ul>
                        <h4>Expand Your Network</h4>
                        <ul>
                          <li>Collaborate with other creators and industry professionals.</li>
                          <li>Hire local talent or support for shoots when traveling to new locations.</li>
                        </ul>
                      </div>
                    </div>
                    </div>
                    <div className="bottom">
                    <h1>Earn More, Work Smarter</h1>
                    <div >
                    <div className="left">
                      <div>
                      <h3>Grow Your Income</h3>
                      <ul>
                        <li>Take on more projects by streamlining pre-production and planning.</li>
                        <li>Maximize your earning potential with a steady flow of brand collaborations.</li>
                      </ul>
                      </div>
                    
                    </div>
                    <div className="right">
                      <div>
                      <h3>Flexible Opportunities</h3>
                      <ul>
                        <li>Work locally or expand your reach globally with remote and on-site gigs.</li>
                        <li>Choose projects that align with your passion and creative expertise.</li>
                      </ul>
                      </div>
                    
                    </div>
                    </div>
                    </div>
                   
                    
                    
                </div>
                <div className="Section-4-MembershipBenefits">
                    <div>
                    <div className="left">
                        <Card size='large' type='default' children={<div></div>}  className='bts-image' backgroundImgSrc={bts_img} />
                    </div>
                    <div className="right">
                        <h3>Get More Clients, Faster!</h3>
                        <h4>Make it easy for businesses to book you.</h4>
                        <p>
                        Our NXTVid platform helps you build a standout video portfolio to attract your ideal clients. Showcase your best work, share your unique story, and offer custom pricing packages that make booking simple. Your portfolio gives clients everything they need to confidently hire your services.
                        </p>
                        <p>
                        Streamline your workflow with powerful tools at <a href="https://app.nxtvid.io" target="_blank" rel="noopener noreferrer" >app.nxtvid.io</a>. From drafting detailed proposals to managing client requests, our tooling saves you time so you can focus on creating amazing content.
                        </p>
                        <p>
                        With NXTVid, you’re equipped to showcase your work, connect with clients, and deliver incredible results.
                        </p>


                        <Button className="CTA-Button-2" label='Apply to Join' size='medium' onClick={()=>handleVideographerSignUpButtonClick(userInfo, "Apply to Join")}/>
                    </div>
                    </div>
                    
                </div>
                <FAQSection />
            </body>
            <footer>
                <Footer/>
            </footer> 
        </div>
    );
}

export default MembershipBenefits;